/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getListFeed.defs.js'
export { main as default } from './getListFeed.defs.js'
